export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const cdnUrl = config?.app?.cdnURL;
    return {
        provide: {
            cdn: (path: string) => cdnUrl ? cdnUrl + 'build/_nuxt/static' +  path : path
        }
    }
})